import * as actionTypes from './actionTypes';
import axios from '../../services/axios'
import {setMessage} from './message';

export const loadNotifications = () => {
    return {
        type: actionTypes.LOAD_NOTIFICATIONS
    }
}

export const concatNotifications = (notifications) => {
    return {
        type: actionTypes.CONCAT_NOTIFICATIONS,
        notifications: notifications.notifications.map((item) => {
            return {...item, fullShow: false};
        }),
        hasNext: notifications.hasNext,
        totalElements: notifications.totalElements,
    };
}

export const resetNotifications = () => {
    return {
        type: actionTypes.RESET_NOTIFICATIONS
    }
}

export const updateNotifications = () => {
    return {
        type: actionTypes.UPDATE_NOTIFICATIONS
    }
}

export const update = (notifications, pageSize) => {
    return async (dispatch) => {
        dispatch(updateNotifications())
        let data = notifications.filter(notification => !notification.isViewed).map(item => ({
            id: item.id,
            isViewed: true
        }))
        if (data.length > 0) {
            await axios.patch('/api/v1/notifications', data)
                .catch(() => {
                    dispatch(setMessage({type: 'warning', text: "Не удалось обновить данные."}))
                });
        }
        dispatch(resetNotifications())
        dispatch(getNotifications(0, pageSize))
        dispatch(getNotViewedNotificationsCount())
    }
}

export const loadNotViewedNotificationsCount = () => {
    return {
        type: actionTypes.LOAD_NOT_VIEWED_NOTIFICATIONS_COUNT
    }
}

export const setNotViewedNotificationsCount = (count) => {
    return {
        type: actionTypes.SET_NOT_VIEWED_NOTIFICATIONS_COUNT,
        totalCount: count
    }
}

export const getNotViewedNotificationsCount = () => {
    return (dispatch) => {
        dispatch(loadNotViewedNotificationsCount())
        axios.get(`/api/v1/notifications/notViewed/count`)
            .then(response => {
                dispatch(setNotViewedNotificationsCount(response.data))
            })
            .catch(error => {
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
            })
    }
}

export const getNotifications = (pageNumber, pageSize) => {
    return (dispatch) => {
        dispatch(loadNotifications())
        axios.get(`/api/v1/notifications?pageNumber=${pageNumber}&pageSize=${pageSize}`)
            .then(response => {
                    dispatch(concatNotifications(response.data))
                }
            ).catch(() => {
            dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
        })
    }
}

export const setFullShow = (index) => {
    return {
        type: actionTypes.SET_FULL_SHOW_FOR_NOTIFICATION,
        index: index
    }
}